import { gql } from '@apollo/client';

export const UPDATE_ENDPOINT = gql`
  mutation UpdateEndpoint(
    $data: EndpointUpdateInput!
    $where: EndpointWhereUniqueInput!
  ) {
    updateEndpoint(data: $data, where: $where) {
      id
      name
      redirectUrl
    }
  }
`;
